module.exports = __webpack_public_path__ + "img/logo_slack.0af7e4e4.svg";